// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"bf5665df","191":"ac5e74b7","215":"4ba984d1","595":"c70b2248","749":"95242760","768":"7616c8a3","850":"780bbc29","865":"9f2722f1","951":"c70b2248"}[chunkId] + ".chunk.css";
};